import { Pipe, PipeTransform } from '@angular/core';
import { Functions } from '../helpers';

@Pipe({
  name: 'cpfCnpj',
  standalone: true,
})
export class CpfCnpjPipe implements PipeTransform {
  transform(value: string | number | undefined): string | number | undefined {
    const valueLength = `${value}`.length
    if (!value || ![11, 14].includes(valueLength)) return value;
    if(valueLength == 11){
      return Functions.formatCPF(`${value}`)
    }else{
      return Functions.formatCNPJ(`${value}`)
    }
  }
}
